'use strict';

var App = require('app');
var AppState = require('app_state');

var HomeComponent = {};

HomeComponent.initializeRouting = function () {
    new HomeComponent.Router({
        controller: API,
    });
};

HomeComponent.Router = App.BaseRouter.extend({
    appRoutes: {
        '': 'showHome',
        dashboard: 'showDashboard',
    },
});

var API = {
    showHome: function (contextData) {
        var controller = require('components/home/home_controller');
        controller.showHome(contextData);
    },

    showDashboard: function () {
        var controller = require('components/dashboard/dashboard_controller');
        controller.initializeDashboard();
    },
};

App.on('home:show', function (contextData) {
    AppState.clearURLParameterCache();
    API.showHome(contextData);
});

App.on('dashboard:show', function () {
    API.showDashboard();
});

module.exports = HomeComponent;
